import { request } from './request';
import * as PATHS from '@/constants/path';
import { URLParamBuilder } from '@/utils/functions';
import { TaskAutomationModel } from '@/typings/models/TaskAutomationModel';

export function fetchTaskAutomationsList({query}: { query?: Record<string, any> } = {}) {
  const url = URLParamBuilder(PATHS.FETCH_TASK_AUTOMATIONS, {
    queryString: query,
  });
  return request(url, {
    method: 'GET',
  });
}

export function fetchTaskAutomationMetaRequest() {
  const url = URLParamBuilder(PATHS.FETCH_TASK_AUTOMATION_META);
  return request(url, {
    method: 'GET',
  });
}

export function getTaskAutomationRequest() {
  const url = URLParamBuilder(PATHS.GET_TASK_AUTOMATION);
  return request(url, {
    method: 'GET',
  });
}

export function fetchSingleTaskAutomationDetailsRequest({
  params,
}: {
  params: { taskAutomationId: string };
}) {
  const url = URLParamBuilder(PATHS.GET_TASK_AUTOMATION, {params});
  return request(url, {
    method: 'GET',
  });
}

export function createTaskAutomationRequest({data}: { data: Omit<TaskAutomationModel, 'id' | 'created_at' | 'modified_at'> }) {
  const url = PATHS.CREATE_TASK_AUTOMATION;
  return request(url, {
    method: 'POST',
    data,
  });
}

export function editTaskAutomationRequest({
  data,
  params,
}: {
  data: Partial<Omit<TaskAutomationModel, 'id' | 'created_at' | 'modified_at'>>;
  params: { taskAutomationId: string };
}) {
  const url = URLParamBuilder(PATHS.EDIT_TASK_AUTOMATION, {params});
  return request(url, {
    method: 'PUT',
    data,
  });
}

export function deleteTaskAutomationRequest({
  params,
}: {
  params: { taskAutomationId: string };
}) {
  const url = URLParamBuilder(PATHS.DELETE_TASK_AUTOMATION, {params});
  return request(url, {
    method: 'DELETE',
  });
}

export function doTaskActionRequest({params}: {
  params: {
    taskId: string,
    actionId: string
  }
}){

  const url = URLParamBuilder(PATHS.DO_TASK_ACTION, {params});
  return request(url, {
    method: 'POST',
  });
}
